import { useQuery } from '@tanstack/react-query';
import { getExerciseTypes } from '../../../api/diary-service';

export const useExerciseTypes = () => {
    return useQuery({
        queryKey: ['exerciseTypes'],
        queryFn: getExerciseTypes,
        staleTime: 1000 * 60 * 5,
        refetchOnWindowFocus: false,
        retry: 1,
        onError: (error) => {
            console.error('Failed to fetch exercise types:', error);
        }
    });
};
